import React, { FC } from "react";
import { Button, Link } from "gatsby-theme-material-ui";
import { SxProps } from "@mui/material";

import { KeyboardArrowRightRounded } from "@mui/icons-material";

import { consoleSignupURL, addUrlParams, addParameters } from "@src/urls";

import { UtmParameters } from "@src/helpers/utms";

interface Props {
  color: string;
  variant?: "outlined" | "contained";
  signup?: boolean;
  label?: string;
  buttonSx?: SxProps;
  ctaUtms?: UtmParameters;
}

const SigninButton: FC<Props> = ({
  color,
  variant = "outlined",
  label = "",
  signup = false,
  buttonSx,
  ctaUtms = {},
}) => {
  const url = addParameters(addUrlParams(consoleSignupURL), ctaUtms);
  const buttonLabel = !label ? (signup ? "Sign up" : "Log in") : label;

  const styles =
    variant === "outlined"
      ? { color: color, borderColor: color, ...buttonSx }
      : { borderColor: color, ...buttonSx };

  return (
    <Link
      href={url}
      target="pangea_signin"
      underline="none"
      sx={{ minWidth: "90px" }}
    >
      <Button
        variant={variant}
        disableRipple
        disableElevation
        fullWidth
        sx={{ ...styles, pl: "20px", pr: "20px" }}
      >
        {buttonLabel}
        <KeyboardArrowRightRounded
          sx={{ marginLeft: "4px", fontSize: "20px" }}
        />
      </Button>
    </Link>
  );
};

export default SigninButton;
